import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import ReduxRecord from './reduxRecord';
import t from '@instructure/quiz-i18n/es/format-message';
export var QuizAnalysis = /*#__PURE__*/function (_ReduxRecord) {
  function QuizAnalysis() {
    _classCallCheck(this, QuizAnalysis);
    return _callSuper(this, QuizAnalysis, arguments);
  }
  _inherits(QuizAnalysis, _ReduxRecord);
  return _createClass(QuizAnalysis, [{
    key: "isLoaded",
    value: function isLoaded() {
      return this.quizId !== '0';
    }
  }, {
    key: "isPresent",
    value: function isPresent() {
      return !this.notFound;
    }
  }, {
    key: "scoreInfo",
    value: function scoreInfo() {
      return this.quizAnalysis.get('scoreInfo', {});
    }
  }, {
    key: "pointsPossible",
    value: function pointsPossible() {
      return this.scoreInfo().get('pointsPossible') || 0;
    }
  }, {
    key: "scoreCount",
    value: function scoreCount() {
      return this.scoreInfo().get('scoreCount') || 0;
    }
  }, {
    key: "formatRatio",
    value: function formatRatio(ratio) {
      return isFinite(ratio) ? t.number(ratio, 'percent') : '--';
    }
  }, {
    key: "meanElapsedTime",
    value: function meanElapsedTime() {
      var scoreCount = this.scoreCount();
      if (scoreCount === 0) return 0;
      var elapsedTimeSum = this.scoreInfo().get('elapsedTimeSum') || 0;
      return Math.round(elapsedTimeSum / scoreCount);
    }
  }, {
    key: "meanScore",
    value: function meanScore() {
      var scoreSum = this.scoreInfo().get('scoreSum') || 0;
      return this.formatRatio(scoreSum / this.scoreCount() / this.pointsPossible());
    }
  }, {
    key: "highScore",
    value: function highScore() {
      var scoreMax = this.scoreInfo().get('scoreMax') || 0;
      return this.formatRatio(scoreMax / this.pointsPossible());
    }
  }, {
    key: "lowScore",
    value: function lowScore() {
      var scoreMin = this.scoreInfo().get('scoreMin') || 0;
      return this.formatRatio(scoreMin / this.pointsPossible());
    }
  }, {
    key: "standardDeviation",
    value: function standardDeviation() {
      var stdDeviation = this.scoreInfo().get('scoreStddevPop');
      return isFinite(stdDeviation) ? t.number(stdDeviation) : null;
    }
  }, {
    key: "centileDistribution",
    value: function centileDistribution() {
      return this.quizAnalysis.get('centile').toArray();
    }
  }, {
    key: "decileDistribution",
    value: function decileDistribution() {
      return this.quizAnalysis.get('decile').toArray();
    }
  }, {
    key: "cronbachsAlpha",
    value: function cronbachsAlpha() {
      var alpha = this.quizAnalysis.get('cronbachsAlpha');
      return isFinite(alpha) ? t.number(alpha) : null;
    }
  }]);
}(ReduxRecord({
  quizId: '0',
  quizAnalysis: null,
  batchTimestamp: null,
  notFound: false
}));
export default QuizAnalysis;